'use strict'

// requires jQuery on page
export default function () {
  var stickymastheadheight = 100

  $(document).on('click', 'a[href^="#"]', function (event) {
    // special case to ignore clicks on tab navigation
    if ($(this).closest('.nav-item').length) return
    if ($(this).closest('.sidebarfilter').length) return
    event.preventDefault()

    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top - stickymastheadheight
    }, 500)
  })
}
